import { useParams } from 'react-router-dom';
import BottomBarProRSSFeedDefaultProps from '../components/BottomBarProRSSFeed.defaultProps.json';
import BottomBarProTargetingDefaultProps from '../components/BottomBarProTargeting.defaultProps.json';
import BottomBarExpandableDefaultProps from '../components/BottomBarExpandable.defaultProps.json';
import OverlayHomeStretchDefaultProps from '../components/OverlayHomeStretch.defaultProps.json';
import OverlayApplicationProDefaultProps from '../components/OverlayApplicationPro.defaultProps.json';
import OverlayMadMoneyCramerDefaultProps from '../components/OverlayMadMoneyCramer.defaultProps.json';
import OverlayCramerInvestingGuideDefaultProps from '../components/OverlayCramerInvestingGuide.defaultProps.json';
import OverlayApplicationProRssDefaultProps from '../components/OverlayApplicationProRss.defaultProps.json';
import InlineWarrenBuffetDefaultProps from '../components/InlineWarrenBuffet.defaultProps.json';
import OverlayProPersonalFinanceDefaultProps from '../components/OverlayProPersonalFinance.defaultProps.json';
import OverlayProNewsDefaultProps from '../components/OverlayProNews.defaultProps.json';

function useComponentCampaignDefaultProps() {
  const { componentName } = useParams();

  const defaultProps =
    {
      BottomBarProRSSFeed: BottomBarProRSSFeedDefaultProps,
      BottomBarProTargeting: BottomBarProTargetingDefaultProps,
      BottomBarExpandable: BottomBarExpandableDefaultProps,
      OverlayHomeStretch: OverlayHomeStretchDefaultProps,
      OverlayApplicationPro: OverlayApplicationProDefaultProps,
      OverlayMadMoneyCramer: OverlayMadMoneyCramerDefaultProps,
      OverlayCramerInvestingGuide: OverlayCramerInvestingGuideDefaultProps,
      OverlayApplicationProRss: OverlayApplicationProRssDefaultProps,
      OverlayProPersonalFinance: OverlayProPersonalFinanceDefaultProps,
      OverlayProNews: OverlayProNewsDefaultProps,
      InlineWarrenBuffet: InlineWarrenBuffetDefaultProps,
    }[componentName] || {};

  return defaultProps;
}

export default useComponentCampaignDefaultProps;
